import React from "react";
import {
  CalendarCheck,
  TrendingUp,
  type LucideProps,
  Lightbulb,
  Share,
  Pencil,
  Trash,
  Sparkles,
  Home,
  Settings,
  UserPen,
  User,
  LogOut,
  CalendarRange,
  Target,
  HeartPulse,
  Repeat,
} from "lucide-react";

const COMMON_ICONS = {
  // resources
  healthAreas: HeartPulse,
  goals: Target,
  routines: Repeat,
  // pages
  home: Home,
  dashboard: CalendarCheck,
  library: Lightbulb,
  // actions
  share: Share,
  edit: Pencil,
  delete: Trash,
  generate: Sparkles,
  profile: UserPen,
  account: User,
  settings: Settings,
  logout: LogOut,
  calendar: CalendarRange,
} as const;

export type CommonIconType = keyof typeof COMMON_ICONS;

interface CommonIconProps extends LucideProps {
  name: CommonIconType;
  active?: boolean;
}

export const CommonIcon = ({ name, active = false, ...props }: CommonIconProps) => {
  const Icon = COMMON_ICONS[name] ?? TrendingUp;
  return <Icon {...props} strokeWidth={active ? 2.25 : 1.75} />;
};
